/**
 * Loads a Django page so its route-specific shell is rendered again.
 */
export const navigateToServerPage = (url: string): void => {
  window.location.assign(url);
};
